<template>
  <NuxtIcon
    v-if="name"
    :name="name"
    v-bind="{ iconname: name }"
    :filled="true"
    class="base-icon"
    :class="[{ 'is-inherit': color === 'inherit' }, { 'has-no-stroke': filled || iconsWithoutStroke.includes(name) }]"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
    }" />
</template>

<script setup lang="ts">
import NuxtIcon from '../../../../../node_modules/nuxt-icons/dist/runtime/components/nuxt-icon.vue';

// These icons do not have a stroke and use "currentColor" for fill.
const iconsWithoutStroke = [
  'fi_linkedin',
  'fi_facebook',
  'fi_instagram',
  'fi_youtube',
  'fi_x-socialmedia',
  'vimeo',
  'fi_wechat',
  'fi_xiaohongshu',
  'fi_tiktok',
];

export interface SharedBaseIconProps {
  name: string;
  /**
   * Size in Pixels
   */
  size?: number;
  /**
   * If you are wondering why this is inherit or false, then you are probably in the wrong component.
   * This component is meant to be used within other shared components.
   * If you want to change the color of the icon, you should do that by using the apps BaseIcon component.
   */
  color: 'inherit' | false;
  filled?: boolean;
}

withDefaults(defineProps<SharedBaseIconProps>(), {
  size: 16,
});
</script>

<style src="./SharedBaseIcon.scss" lang="scss" scoped />
